<template>
    <v-container fluid grid-list-md>
    {{lang.TravelOrders}}
    <v-row no-gutters>
            <v-col cols="12" sm="3" md="3" xs="3" lg="3" xl="3" class="py-0 px-2">
              
            </v-col>
            <v-col cols="12" sm="4" md="4" xs="4" lg="4" xl="4" class="py-0 px-2">
               <v-btn text @click="printTravels">Print</v-btn>
               <v-btn fab dark fixed right class="indigo" @click="newdocument">
                 <v-icon dark>mdi-plus</v-icon>
                </v-btn>
            </v-col>
          </v-row>
            
    <TravelOrderList />
    <TravelOrderPrintList ref="prnt" />
    </v-container>
</template>

<script>
import TravelOrderList from './TravelOrderList'
import TravelOrderPrintList from './TravelOrderPrintList'
import ledgerEN from './travelorderDescEn'
import ledgerHR from './travelorderDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"
import TravelOrderService from '@/services/TravelOrderService'

export default {
  name: 'travelorder',
  data () {
    return {
      lang: {},
      langC: {},
      mainQuery: {},
      items:[],
      card: null

    }
  },
  mounted () {
    if (this.$store.state.language === "EN") {
      this.lang = ledgerEN
      this.langC = commEn
    }
    if (this.$store.state.language === "HR") {
      this.lang = ledgerHR
      this.langC = commHr
    }
  },
  methods: {
    async newdocument () {
      try {
        this.$store.dispatch('seteditItem', 0)
        await this.$router.push({
          name: 'travelordercreate'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async printTravels() {
        this.mainQuery.CompanyId = this.$store.state.companyid ? this.$store.state.companyid : 0
        this.mainQuery.businessYear = this.$store.state.businessYear ? this.$store.state.businessYear : 2023

        this.saving = true
        const {data} = (await TravelOrderService.index(this.mainQuery))
        this.items = data.travelorders && data.travelorders.length > 0 ? data.travelorders : []
        const newObj = {}
        this.card = {...newObj}
        this.card.head1 = this.items ? this.items : []
        this.card.head2 = ''
        this.card.head3 = null
        this.card.head4 = null
        this.card.head5 = null
        console.log('this.card', this.card)
        this.$store.dispatch('setPrintObj', this.card)
        this.$refs.prnt.print()
    }
  },
  computed: {
  },
  watch: {

  },
  components: {
    TravelOrderList,
    TravelOrderPrintList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
